import { ColumnsType } from 'antd/lib/table';
import { RequestStatusType, ZupRequestStatusType } from 'shared/enums';
import { TVacationScheduleRequestSupervisor } from 'app/services/edpApiV1/supervisor/vacationsSchedule';
import { Pagination } from './types';

export type TVacantionScheldulePosition = {
  id: string;
  name: string;
  validFrom: string;
  validTo: string;
};

export type TVacantionSchelduleDivision = TVacantionScheldulePosition & {
  code: string;
};

export type TVacantionSchelduleImage = {
  id: number;
  filename: string;
  path: string;
  uri: string;
};

export enum VSUserSearchType {
  FIO = 'ФИО',
  PERSONNEL_NUMBER = 'Табельный номер',
}

export type TVacationScheduleInfo = {
  id: number;
  personnelNumber: string;
  name: string;
  lastName: string;
  middleName: string;
  position: string;
  division: string;
  scheduleRequests:
    | [
        {
          id: number;
          // status: string;
          status: { type: RequestStatusType; name: string };
          zupRequestStatus: { type: ZupRequestStatusType; name: string } | null;
          comment: string | null;
          startedAt: string;
          endedAt: string;
          isSupervisorApproved: boolean;
          amountDays: number;
          vacationType: {
            id: string;
            name: string;
          };
        },
      ]
    | [];
};

export interface DataScheduleType {
  key: string | number;
  id: string | number;
  status?: { type: RequestStatusType; name: string; isSupervisorApproved: boolean } | null;
  zupRequestStatus?: { type: ZupRequestStatusType; name: string } | null;
  comment?: string | null;
  startedAt: string;
  endedAt: string;
  amountDays?: number;
  resultDays?: number;
  vacationType?:
    | {
        id: string;
        name: string;
      }
    | string;
}

export interface DataDaysScheduleType {
  key: string;
  id: string;
  vacationType: string;
  amountDays: number;
  resultDays: number;
}

export type TScheduleData = {
  id: number;
  personnelNumber: string | null;
  name: string | null;
  lastName: string | null;
  middleName: string | null;
  position: string;
  division: string;
  scheduleRequests?: DataScheduleType[];
};

export type TTypeSchedule = {
  vacationTypeId: string | number;
  name: string;
  amountDays: number;
};

export type TPreparedAcceptSettings = {
  key: string;
  division: string;
  fio: string;
  agreementDepth: number;
};

export type TPreparedAcceptSettingsColumns = ColumnsType<TPreparedAcceptSettings>;

export type TAddStepRequest = {
  divisionId: string;
};

export type TUpdateStepRequest = {
  divisionId: string;
  agreementDepth: number;
};

export type TVacationSupervisers = {
  id: string;
  code: string;
  name: string;
  validFrom: string;
  validTo: string;
  agreementDepth: number;
  supervisor: {
    id: number;
    name: string;
    lastName: string;
    middleName: string;
    position: {
      id: string;
      name: string;
      validFrom: string;
      validTo: string;
    };
    division: {
      id: string;
      code: string;
      name: string;
      validFrom: string;
      validTo: string;
    };
    image: {
      id: number;
      filename: string;
      path: string;
      uri: string;
    };
  };
  organization: {
    id: string;
    name: string;
  };
};
export type TVacationSupervisersPaginated = {
  data: TVacationSupervisers[];
  pagination: Pagination;
};

export type TAddApplicationStepResponse = {
  id: string;
  name: string;
  code: string;
  agreementDepth: number;
  agreementDepthMax: number;
  agreementDepthList: [
    {
      id: string;
      supervisor_division_id: string;
      name: string;
      code: string;
    },
  ];
};

export type TGetVacationApplicationsRequest = { size: number; page: number; organizationId?: string; search?: string };

export type TVacationScheduleRequest = {
  id: number;
  startedAt: string;
  endedAt: string;
  status: {
    type: string;
    name: string;
  };
  amountDays: number;
  comment: string;
  vacationType: {
    id: string;
    name: string;
  };
  supervisor: {
    id: number;
    name: string;
    lastName: string;
    middleName: string;
    position: TVacantionScheldulePosition;
    division: TVacantionSchelduleDivision;
    image: TVacantionSchelduleImage;
    role: string;
  };
};

export type TVacationScheduleSubordinate = {
  id: number;
  name: string;
  lastName: string;
  middleName: string;
  position: TVacantionScheldulePosition;
  division: TVacantionScheldulePosition;
  image: TVacantionSchelduleImage;
  requests: TVacationScheduleRequest[];
};

export type TVacationScheduleSubordinatePrepared = {
  fio: string;
  key: number;
  id: number;
  requests?: TVacationScheduleRequestSupervisor[];
  scheduleRequests?: TVacationScheduleRequestSupervisor[];
};

export type TVacationScheduleSubordinatePaginated = {
  data: TVacationScheduleSubordinate[];
  pagination: Pagination;
};

export type TVacationScheduleRequestPrepared = {
  id: number;
  key: number;
  fio: string;
  vacationType: string;
  type: string;
  startedAt: string;
  endedAt: string;
  amountDays: number;
  status: {
    name: string;
    type: RequestStatusType;
  };
};
